import { render, staticRenderFns } from "./biddingProFile.vue?vue&type=template&id=2293bfdd&scoped=true&"
import script from "./biddingProFile.vue?vue&type=script&lang=js&"
export * from "./biddingProFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2293bfdd",
  null
  
)

export default component.exports